//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { eventEmitter } from "@/main.js";
import { mapGetters, mapActions } from "vuex";

export default {
	name: "wallet-tile",
	props: {
		tileKey: {
			type: String,
			required: true,
		},
		tileProps: {
			type: Array,
			required: true,
		},
	},
	data: () => ({
		data: [],
		ticker: null,
		filter: null,
		name: null,
		exchange: null,
		loading: false,
		requestsGroup: {},
	}),
	methods: {
		...mapActions(["getWallets", "deleteTile"]),

		async fetchData() {
			try {
				this.loading = true;
				this.data = await Promise.all(
					Object.entries(this.requestsGroup).map(
						async ([exchangeName, walletsList]) => {
							const data = await this.getWallets({
								exchange: exchangeName,
								wallets: walletsList,
							});
							const { wallets, exchange } = data;
							return { wallets, exchange };
						}
					)
				);
			} catch (e) {
				this.loading = false;
				console.warn("Error while executing wallets request", e);
			} finally {
				this.loading = false;
			}
		},
		async requestGroup() {},
		removeTile() {
			this.deleteTile(this.key);
		},
		redirect() {
			window.open(this.link);
		},
		async refresh() {
			await this.fetchData();
		},
	},
	watch: {
		tileProps: {
			immediate: true,
			async handler(wallets) {
				if (wallets) {
					const request = {};
					wallets.forEach((w) => {
						if (!request[w.exchange]) {
							request[w.exchange] = [w];
						} else {
							request[w.exchange].push(w);
						}
					});
					this.requestsGroup = request;
					await this.fetchData();
				}
			},
		},
	},
	computed: {
		key() {
			return this.tileKey;
		},
		chartData() {
			return this.data;
		},
	},
};
